document.addEventListener("DOMContentLoaded", function (event) {
    const items = document.querySelectorAll(".menu-item-object-glossary a")
    items.forEach(html => {
        const item = html.innerText
        if (item.includes("<img")) {
            const img = item.split("<img")[1]
            html.innerHTML = "<img" + img
        }
    })

    const container = document.querySelector(".megamenu-parent-herb-glossary .container")
    if (container) {
        const title = document.createElement("h2")
        const subtitle = document.createElement("span")
        const link = document.createElement("a")
        let href = 'https://blog.organicolivia.com/glossary/';
        title.innerHTML = "Know Your Herbs"
        subtitle.innerHTML = "Just like us humans, herbs have their own personalities, traditions, and wisdom. Nerd out on the plants in our formulas to cultivate a deeper relationship with the allies in your apothecary."
        link.innerHTML = "<a href='" + href + "' class='blog-glossary font-special'>View Full Herb Glossary</a>"
        container.insertBefore(subtitle, container.firstElementChild).setAttribute('class', "sub-title-glossary");
        container.insertBefore(title, container.firstElementChild).setAttribute('class', "title-glossary font-special");
        container.appendChild(link)
    }
});